import mixpanel from 'mixpanel-browser';
import { Merchant } from '@anticatrade/shared';

mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
	autocapture: true,
	record_sessions_percent: 100,
	record_mask_all_text: false,
	record_mask_all_inputs: false,
	api_host: 'https://api-eu.mixpanel.com',
	debug: false,
});

function identify(merchant: Merchant) {
	mixpanel.identify(String(merchant.id));
	const logoUrl = `${import.meta.env.VITE_MERCHANT_IMAGE_URL}/${merchant.id}/${merchant.logo.fileName}.webp`;
	mixpanel.people.set({
		$email: merchant.email,
		$first_name: merchant.name,
		$avatar: logoUrl,
	});
}

function track(event: string, properties?: Record<string, unknown>) {
	mixpanel.track(event, properties);
}

function reset() {
	mixpanel.reset();
}

export const analytics = { identify, track, reset };
